import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"id":"logo-alipay","fill":"props.strokeColor1","d":"M10.5 2H12.5V4.78768H19.5018V6.78768H12.5V8.64495H17.7643L17.5658 9.81254C17.3047 11.3488 16.5881 12.9667 15.6173 14.4693C16.9118 14.9159 18.1896 15.3888 19.4102 15.8406L19.6428 15.9267C21.219 16.5099 22.6869 17.0494 24 17.4614V21.2888L23.5636 21.0694L23.5049 21.0401C23.4655 21.0204 23.4067 20.9911 23.3299 20.953C23.1763 20.8768 22.9506 20.7654 22.6637 20.6254C22.0899 20.3452 21.2717 19.9505 20.2962 19.4932C18.5153 18.6584 16.2179 17.6189 13.9291 16.6876C12.9032 17.8444 11.7295 18.8793 10.5008 19.6624C9.17994 20.5041 7.73348 21.0938 6.30325 21.168C6.20244 21.1733 6.10146 21.1759 6.00036 21.1759C4.17247 21.1759 2.73249 20.6909 1.75042 19.8335C0.757794 18.967 0.314967 17.7861 0.398632 16.6106C0.567055 14.2441 2.77152 12.2151 6.02849 12.3067C8.2767 12.37 10.7335 12.9311 13.1573 13.6672C13.7573 12.6691 14.2302 11.6336 14.5335 10.6449H5.50069V8.64495H10.5V6.78768H3.50058V4.78768H10.5V2ZM5.97223 14.3059C3.58475 14.2387 2.47244 15.6446 2.39359 16.7525C2.35361 17.3142 2.55452 17.8806 3.06573 18.3269C3.5875 18.7824 4.51146 19.1759 6.00036 19.1759C7.72982 19.1759 9.73338 17.9501 11.4765 15.9699C11.5282 15.9112 11.5795 15.852 11.6303 15.7924C9.40672 14.9705 7.45602 14.3945 6.24418 14.3163C6.153 14.3119 6.06235 14.3085 5.97223 14.3059Z"}}]};

const LogoAlipay = Vue.extend<IconProps>({
  name: 'LogoAlipayIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'logo-alipay',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default LogoAlipay;
